export enum PositionSimulationActivationTrigger {
  None = 'None',
  UserInteraction = 'UserInteraction',
  Automatically = 'Automatically'
}
